
namespace GeniuzPOS.AdvPromo {

    @Serenity.Decorators.registerClass()
    export class LookupAvPromoCouponTypesDialog extends Serenity.EntityDialog<LookupAvPromoCouponTypesRow, any> {
        protected getFormKey() { return LookupAvPromoCouponTypesForm.formKey; }
        protected getIdProperty() { return LookupAvPromoCouponTypesRow.idProperty; }
        protected getLocalTextPrefix() { return LookupAvPromoCouponTypesRow.localTextPrefix; }
        protected getNameProperty() { return LookupAvPromoCouponTypesRow.nameProperty; }
        protected getService() { return LookupAvPromoCouponTypesService.baseUrl; }
        protected getDeletePermission() { return LookupAvPromoCouponTypesRow.deletePermission; }
        protected getInsertPermission() { return LookupAvPromoCouponTypesRow.insertPermission; }
        protected getUpdatePermission() { return LookupAvPromoCouponTypesRow.updatePermission; }

        protected form = new LookupAvPromoCouponTypesForm(this.idPrefix);

    }
}